/**
 * ID enums, corresponding to the ids of the items in each of the csv files
 */
export enum RegionIds {
  MELANESIA = 1,
  POLYNESIA = 2,
  MICRONESIA = 3
}

/**
 * TypeScript enums for CSV column headers
 * Maps verbose user-facing column names to concise enum keys
 */

// Islands CSV Headers
export enum IslandHeaders {
  ID = "Island ID (feel free to leave blank)",
  NAME = "Name",
  INDIGENOUS_NAME = "Indigenous Name",
  DESCRIPTION = "Description",
  GENETICS = "Genetics",
  CULTURE = "Culture",
  LINGUISTICS = "Linguistics",
  GEOLOGY = "Geology",
  CLIMATE = "Climate",
  PHOTOGRAPH = "Photograph (with caption)",
  NOTES = " Notes (For developer only, not student-facing)"
}

// Cultural Regions CSV Headers
export enum CulturalRegionHeaders {
  ID = "Region ID (feel free to leave blank)",
  NAME = "Name",
  DESCRIPTION = "Description",
  GENETICS = "Genetics",
  CULTURE = "Culture",
  LINGUISTICS = "Linguistics",
  NOTES = "Non-student-facing Notes (e.g., Fiji overlap)"
}

// Migration Routes CSV Headers
export enum MigrationRouteHeaders {
  ID = "Route ID",
  NAME = "Name",
  DATE_RANGE = "Approx. Date Range",
  COLONIAL_POWER = "Colonial Power",
  ORIGIN = "Origin",
  DESTINATION = "Destination",
  LINGUISTICS = "Linguistics",
  DESCRIPTION = "Description",
  PHOTOGRAPH = "Photograph (with caption)",
  NOTES = "Notes (For developer only, not student-facing)"
}

// Diasporas CSV Headers
export enum DiasporaHeaders {
  ID = "Diaspora ID (feel free to leave blank)",
  ORIGIN = "Origin",
  DESTINATION = "Destination",
  DATES = "Dates",
  LANGUAGES = "Languages",
  CULTURES = "Cultures Involved",
  COLONIAL_POWER = "Colonial Power",
  DESCRIPTION = "General Description/History",
  NOTES = "Notes (For developer only, not student-facing)"
}
